import Record from './base'
import moment from 'moment'

export class Donation extends Record {
  constructor(...args) {
    super(...args)
    const [model, props] = args
    this.orderableDate = moment(
      this.donation_time,
      'YYYY-MM-DD HH:mm:ss'
    ).valueOf()
  }
}



// WEBPACK FOOTER //
// ./src/store/serializers/donation.js